import { createTheme } from "@mui/material/styles";
export const defaultTheme = createTheme({
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    letterSpacing: "0",
                    fontFamily: '"Open Sans", sans-serif',
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                notchedOutline: {
                    borderColor: "rgba(0, 0, 0, 0.12)",
                },
                input: {
                    fontFamily: '"Open Sans", sans-serif',
                    fontStyle: "normal",
                    fontWeight: "normal",
                    fontSize: "14px",
                    lineHeight: "120%",
                    letterSpacing: "0",
                    padding: "15px 14px",
                    color: "#333333",
                },
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    fontSize: "14px",
                },
                shrink: {
                    transform: "translate(14px, -7px) scale(0.85)",
                },
            },
        },
        MuiFormLabel: {
            styleOverrides: {
                root: {
                    fontFamily: '"Open Sans", sans-serif',
                    fontStyle: "normal",
                    fontWeight: "normal",
                    fontSize: "16px",
                    lineHeight: "120%",
                    letterSpacing: "0",
                    color: "#828282",
                    "&$focused": {
                        color: "#828282",
                    },
                },
            },
        },
        MuiDialog: {
            styleOverrides: {
                paper: {
                    borderRadius: "0 !important",
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    fontFamily: '"Open Sans", sans-serif',
                    fontStyle: "normal",
                    fontWeight: 400,
                    fontSize: "12px",
                    lineHeight: "120%",
                    letterSpacing: "0",
                    textTransform: "capitalize",
                },
            },
        },
        MuiButtonBase: {
            styleOverrides: {
                root: {
                    fontFamily: '"Open Sans", sans-serif',
                },
            },
        },
    },
    palette: {
        primary: {
            light: "#2196F3",
            main: "#2770CA",
            dark: "#0f5acd",
        },
    },
});
